import Vue from 'vue'

/** 全局注册 **/

Vue.directive('jump', {
  //  bind 只调用一次，指令第一次绑定到元素时候调用，用这个钩子可以定义一个绑定时执行一次的初始化动作。
  //  inserted:被绑定的元素插入父节点的时候调用(父节点存在即可调用，不必存在document中)
  //  update: 被绑定与元素所在模板更新时调用，而且无论绑定值是否有变化，通过比较更新前后的绑定值，忽略不必要的模板更新
  //  componentUpdate :被绑定的元素所在模板完成一次更新更新周期的时候调用
  //  unbind: 只调用一次，指令月元素解绑的时候调用
  bind: function (el, bingind, vnode) {
    el.onclick = function (event) {
      event.preventDefault();
      event.stopPropagation();
      console.log(bingind.value)
      vnode.context.$router.push({
        path: bingind.value
      })
    }
  },
  inserted: function () {
    console.log("2-insert");
  },
  update: function (el, bingind, vnode) {
    el.onclick = function () {
      console.log(bingind.value)
      vnode.context.$router.push({
        path: bingind.value
      })
    }
  },
  componentUpdated: function () {
    console.log('4 - componentUpdated');
  },
  unbind: function () {
    console.log('5 - unbind');
  }
})



// WEBPACK FOOTER //
// ./src/directives/directives.js